// css文件中不要使用import
import '../css/reset.css';
import '../css/base.css';
import '../css/index.css';
import '../css/project.css';

require('./seed');
// require('./seed.auth'); // 需要授权的活动
require('./config');

import Clipboard from 'clipboard';

import native from 'c-up-native';

import pageConfig from './pageConfig';

import pageTpl from './template/page.tmpl';
import blockTpl from './template/block.tmpl';
import tabContentTpl from './template/tab-content.tmpl';

import notification  from 'c-notification';

import FastClick from 'c-fastclick';
FastClick.attach(document.body);

let Game = {
    init: function() {
        let self = this;
        console.log(UpAct.lang.template('TITLE'))
        let app = new UpAct.AppBase({
            title: UpAct.lang.template('TITLE')
        });

        self.renderHTML();
    },

    renderHTML: function() {
        // let actInfo = UpAct.actData[UpAct.CONFIG.acid];

        let html = pageTpl({
            // actInfo: actInfo
        });

        $('#wrap').html(html);

        this.createDeviceTab($("#page-content"));

        this.bindEvent();
    },

    /* 生成设备选择tab */
    createDeviceTab(panel){
        let self = this;

        let tabHtml = tabContentTpl({
            tabs: pageConfig,
            tabObjIndex: 1,
            tabTitle: ''
        })

        panel.html(tabHtml);

        let tab = new UpAct.TabView({
            wrap: panel,
            direction: UpAct.lang.langType == 'areg' ? 'right' : 'left'
        });

        tab.on('select', function(e) {
            let _panel = e.panel;
            let _index = e.index;

            let item = pageConfig[_index];
            self.renderPage(_panel,item.prefix,_index,item.name);

            //self.createStepTab(_panel,item.data,item.title);
        });

        tab.render();
    },

    /* 生成开播步骤tab */
    createStepTab(panel,data,title){

        let self = this;

        let tabHtml = tabContentTpl({
            tabs: data,
            tabObjIndex: 2,
            tabTitle: title
        })

        panel.html(tabHtml);

        let tab = new UpAct.TabView({
            wrap: panel,
            direction: UpAct.lang.langType == 'areg' ? 'right' : 'left'
        });

        tab.on('select', function(e) {
            let _panel = e.panel;
            let _index = e.index;
            let item = data[_index];
            
            self.renderPage(_panel,item.prefix,item.title,_index);
        });

        tab.render();
    },

    bindEvent(){
        let self = this;

        $("#wrap").on("click","a",function(e){
            e.preventDefault();
            let src = $(this).attr("data-src");
            let allowPhoneDownload = $(this).attr("data-allow") === "false" ? false : true;
            let isObs = $(this).attr("data-is-obs") === "false" ? false : true;
            
            if(UpAct.device.isOther){
                window.open(src);
            }else if(!allowPhoneDownload){
                if(isObs){
                    self.createObsTip();
                }else{
                    notification.simple(UpAct.lang.template('PC_DOWNLOAD_ERROR'))
                }
            }else if(UpAct.platform.isUplive){
                native.openBrowser({
                    url: src,
                    errtip: '不支持'
                })
            }else{
                window.open(src);
            }

        });
        
    },

    /* 提示下载 */
    createObsTip(){

        let self = this;
        let popUp = new UpAct.PopLayer({
            content:[
                '<div class="content-bd-in">',
                    '<div class="copy-tip">'+UpAct.lang.template('iOS_DOWNLOADOBS_TOOLTIP')+'</div>',
                    '<p class="hidden">'+UpAct.lang.template('iOS_DOWNLOADOBS_TOOLTIP_REALLINK')+'</p>',
                    '<div class="content-ft">',
                        '<button class="confirm-btn normal-btn copy-btn">'+UpAct.lang.template('iOS_DOWNLOADOBS_TOOLTIP_COPYBUTTPON')+'</button>',
                    '</div>',
                '</div>',
            ].join(''),
            //confirmBtn: UpAct.lang.template('iOS_DOWNLOADOBS_TOOLTIP_COPYBUTTPON'),
        });

        popUp.on('create',(el)=>{
            el.addClass("widget-poplayer-obs-tip");

            el.on('click', '.copy-btn' , function (e) {

                let clipboard = new Clipboard('.copy-btn', {
                    text: ()=>{
                        return UpAct.lang.template('iOS_DOWNLOADOBS_TOOLTIP_REALLINK');
                    }
                })

                clipboard.on('success', ({text}) => {
                    notification.simple(UpAct.lang.template('COPY_SUCCESS'));
                })

                clipboard.on('error', ({action}) => {

                    el.find(".content-bd-in p").removeClass("hidden");
                    notification.simple(UpAct.lang.template('COPY_FAIL'));

                })
            });
        });

        popUp.create();
    },

    /* 生成开播步骤tab */
    renderPage(panel,prefix,index,name){
        let html = blockTpl({
            boxIndex:index,
            prefix,
            deviceName: name,
        })
        panel.html(html)

        this.checkImg(panel);
    },

    checkImg(panel){
        let imgList = $("img",panel);


        imgList.each(function(i,e){
            let itemElm = $(e);
            let src = itemElm.data("src");
            let img = new Image();
            img.src = src;

            console.log(itemElm.data("src"))

            img.onload = function(){
                let width = img.width;
                let height = img.height;
                console.log(width,height)

                itemElm.css({width:width*10/640+'rem'})
                itemElm.attr("src",src)
            }

        })
    }


};


$.getScript(langUrl + '?t=' + (+ new Date()) , function(){
    UpAct.lang.init();
    $.channel.on('gameInit',function(){
        Game.init();
    })
    Game.init();
});

$(function () {
    var isPageHide = false;
    window.addEventListener('pageshow', function () {
        if (isPageHide) {
            window.location.reload();
        }
    });

    window.addEventListener('pagehide', function () {
        isPageHide = true;
    });
})



// WEBPACK FOOTER //
// ./js/app.js